import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import { ITableColumn } from 'src/components/Table/types';
import TableRow from '../TableRow/TableRow';
import './TableGroupRow.scss';

interface TableGroupRowProps {
  data: any;
  columns: ITableColumn[];
  index: number;
  style?: CSSProperties;
  isExpanded: boolean;
}

const TableGroupRow = ({
  data,
  columns,
  index,
  style,
  isExpanded,
}: TableGroupRowProps) => {
  const cellClass = (c: ITableColumn): string => {
    return classNames('juniper-datatable-groupcell', {
      'juniper-datatable-center': c.center,
      'juniper-datatable-emphasis': isExpanded,
      'juniper-datatable-sticky-col': c.sticky,
    });
  };

  return (
    <React.Fragment key={`group-header-container-${index}`}>
      <div
        role="row"
        key={'group-header-' + data.id}
        className="juniper-datatable-row"
        style={style}
      >
        {columns.map((c: ITableColumn, x: number) =>
          c.groupedHeaderCell ? (
            <div
              role="cell"
              key={`group-td=${x}-${data.id}-${index}`}
              style={{ overflow: 'visible' }}
              className={cellClass(c)}
            >
              {c.groupedHeaderCell({ ...data, isExpanded })}
            </div>
          ) : (
            <div
              role="cell"
              key={`group-td=${x}-${data.id}-${index}`}
              className={cellClass(c)}
            />
          )
        )}
      </div>
      {isExpanded &&
        data.children.map((d: any, i: number) => (
          <TableRow
            data={{ ...d, isChild: true }}
            columns={columns}
            index={`${i}-group-${index}`}
            emphasis
          />
        ))}
    </React.Fragment>
  );
};

export default TableGroupRow;